import Button from "@/components/Button/Button";
import Modal from "@/components/Modal/Modal";
import styles from "./CancelQueuedPlanModal.module.scss";

interface CancelQueuedPlanModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const CancelQueuedPlanModal = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}: CancelQueuedPlanModalProps) => {
  return (
    <Modal
      bottomSheetOnMobile
      bodyClassName={styles.modalBody}
      className={styles.modalShell}
      closeModal={() => onClose()}
      heading={
        <div className={styles.headingBlock}>
          <div className={styles.handle} />
          <h2 className={styles.title}>Cancel Queued Plans?</h2>
          <p className={styles.description}>
            This will remove all scheduled membership changes that have not taken effect yet.
          </p>
        </div>
      }
      modalOpen={open}
    >
      <Button
        className={styles.confirmButton}
        disabled={isSubmitting}
        onClick={onConfirm}
        type="button"
      >
        {isSubmitting ? "Cancelling..." : "Yes, Cancel"}
      </Button>

      <Button
        className={styles.dismissButton}
        disabled={isSubmitting}
        onClick={onClose}
        outlined
        type="button"
      >
        No, Never Mind
      </Button>
    </Modal>
  );
};

export default CancelQueuedPlanModal;
